
import React from 'react'
import AddCompanyMaster from '../../../components/companyMaster/addCompanyMaster/AddCompanyMaster'

const AddCompanyMasterPage = () => {
    return (
        <AddCompanyMaster />
    )
}

export default AddCompanyMasterPage